export interface AiSuggestionIssue {
    id: number;
    question: string;
}

export const aiSuggestionIssueMap: Map<string, AiSuggestionIssue[]> = new Map<string, AiSuggestionIssue[]>([
    ["en", [
        { id: 1, question: "My password doesn't work, how can I fix it?" },
        { id: 2, question: "Microsoft Authenticator isn't working, what should I do?" },
        { id: 3, question: "I can't send or receive emails, how can I fix it?" },
        { id: 4, question: "How can I request or renew a PKI certificate?" },
        { id: 5, question: "What is MyHelp?" },
    ]],
    ["de", [
        { id: 1, question: "Mein Passwort funktioniert nicht. Wie kann ich das Problem beheben?" },
        { id: 2, question: "Microsoft Authenticator funktioniert nicht. Was soll ich tun?" },
        { id: 3, question: "Ich kann keine E-Mails senden oder empfangen. Wie kann ich das beheben?" },
        { id: 4, question: "Wie kann ich ein PKI-Zertifikat beantragen oder erneuern?" },
        { id: 5, question: "Was ist MyHelp?" },
    ]],
    ["sv", [
        { id: 1, question: "Mitt lösenord fungerar inte. Hur kan jag fixa det?" },
        { id: 2, question: "Microsoft Authenticator fungerar inte. Vad ska jag göra?" },
        { id: 3, question: "Jag kan inte skicka eller ta emot e-post. Hur kan jag lösa det?" },
        { id: 4, question: "Hur kan jag begära eller förnya ett PKI-certifikat?" },
        { id: 5, question: "Vad är MyHelp?" },
    ]],
    ["ro", [
        { id: 1, question: "Parola mea nu funcționează. Cum pot rezolva problema?" },
        { id: 2, question: "Microsoft Authenticator nu funcționează. Ce ar trebui să fac?" },
        { id: 3, question: "Nu pot trimite sau primi e-mailuri. Cum pot rezolva problema?" },
        { id: 4, question: "Cum pot solicita sau reînnoi un certificat PKI?" },
        { id: 5, question: "Ce este MyHelp?" },
    ]],
    ["it", [
        { id: 1, question: "La mia password non funziona. Come posso risolvere il problema?" },
        { id: 2, question: "Microsoft Authenticator non funziona. Cosa devo fare?" },
        { id: 3, question: "Non riesco a inviare o ricevere email. Come posso risolvere il problema?" },
        { id: 4, question: "Come posso richiedere o rinnovare un certificato PKI?" },
        { id: 5, question: "Che cos'è MyHelp?" },
    ]],
    ["nl", [
        { id: 1, question: "Mijn wachtwoord werkt niet. Hoe kan ik dit oplossen?" },
        { id: 2, question: "Microsoft Authenticator werkt niet. Wat moet ik doen?" },
        { id: 3, question: "Ik kan geen e-mails verzenden of ontvangen. Hoe kan ik dit oplossen?" },
        { id: 4, question: "Hoe kan ik een PKI-certificaat aanvragen of verlengen?" },
        { id: 5, question: "Wat is MyHelp?" },
    ]],
    ["hu", [
        { id: 1, question: "A jelszavam nem működik. Hogyan tudom megoldani?" },
        { id: 2, question: "A Microsoft Authenticator nem működik. Mit tegyek?" },
        { id: 3, question: "Nem tudok e-maileket küldeni vagy fogadni. Hogyan javíthatom ki?" },
        { id: 4, question: "Hogyan igényelhetek vagy újíthatok meg PKI tanúsítványt?" },
        { id: 5, question: "Mi az az MyHelp?" },
    ]],
    ["cz", [
        { id: 1, question: "Moje heslo nefunguje. Jak to mohu opravit?" },
        { id: 2, question: "Microsoft Authenticator nefunguje. Co mám dělat?" },
        { id: 3, question: "Nemohu odesílat ani přijímat e-maily. Jak to mohu opravit?" },
        { id: 4, question: "Jak mohu požádat o certifikát PKI nebo jej obnovit?" },
        { id: 5, question: "Co je MyHelp?" },
    ]],
    ["pl", [
        { id: 1, question: "Moje hasło nie działa. Jak mogę to naprawić?" },
        { id: 2, question: "Microsoft Authenticator nie działa. Co powinienem zrobić?" },
        { id: 3, question: "Nie mogę wysyłać ani odbierać e-maili. Jak mogę to naprawić?" },
        { id: 4, question: "Jak mogę poprosić o certyfikat PKI lub go odnowić?" },
        { id: 5, question: "Co to jest MyHelp?" },
    ]]
]);